"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickStaffDialog = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf/useSelf"));
const StaffChooser_1 = __importDefault(require("@opsbase/web-data-choosers/StaffChooser/StaffChooser"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const WizardDialog_1 = __importDefault(require("@opsbase/web-dialogs/WizardDialog"));
const ImageEditorDialog_1 = __importDefault(require("@opsbase/web-image/ImageEditorDialog"));
const ImageTakerDialog_1 = __importDefault(require("@opsbase/web-image/ImageTakerDialog/ImageTakerDialog"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
function PickStaffDialog(props) {
    var _a, _b;
    const { onSelectStaff, onClose, selfieRequired = true } = props;
    const [showImageTaker, setShowImageTaker] = (0, react_1.useState)(false);
    const [userImage, setUserImage] = (0, react_1.useState)();
    const [editedUserImage, setEditedUesrImage] = (0, react_1.useState)();
    const [staff, setStaff] = (0, react_1.useState)();
    const hasImage = !!userImage;
    const hasAnswer = !!editedUserImage;
    const showImageEditor = !hasAnswer && hasImage;
    const showTake = !hasAnswer && !hasImage;
    const showDelete = hasAnswer;
    const self = (0, useSelf_1.default)();
    const isSelfieRequired = selfieRequired && self.selfieRequired;
    const handleChangeStaff = (0, react_1.useCallback)(v => {
        setStaff(v === null || v === void 0 ? void 0 : v[0]);
    }, []);
    const handleCancel = (0, react_1.useCallback)(() => {
        setShowImageTaker(false);
        setUserImage(undefined);
        setEditedUesrImage(undefined);
    }, []);
    const handleDone = (0, react_1.useCallback)(() => {
        onSelectStaff(staff, editedUserImage);
    }, [onSelectStaff, staff, editedUserImage]);
    const handleAccept = (0, react_1.useCallback)((newUserImage) => __awaiter(this, void 0, void 0, function* () {
        setEditedUesrImage(newUserImage);
    }), [setEditedUesrImage]);
    const handleAllowNext = (0, react_1.useCallback)(stepNumber => {
        switch (stepNumber) {
            case 0:
                return !!staff;
            case 1:
                return !!editedUserImage;
        }
    }, [staff, editedUserImage]);
    const handleAcceptTake = (0, react_1.useCallback)((newUserImage) => __awaiter(this, void 0, void 0, function* () {
        setUserImage(newUserImage);
        setShowImageTaker(false);
    }), [setUserImage]);
    const handleClickTake = (0, react_1.useCallback)(() => setShowImageTaker(true), []);
    const steps = [
        react_1.default.createElement(StaffChooser_1.default, { value: staff ? [staff] : [], filters: { team: (_b = (_a = self === null || self === void 0 ? void 0 : self.accessibleTeams) === null || _a === void 0 ? void 0 : _a.ids) !== null && _b !== void 0 ? _b : [] }, onChange: handleChangeStaff }),
    ];
    if (isSelfieRequired) {
        steps.push(react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Vertical_1.default, { centered: true, gutter: true },
                react_1.default.createElement(Pane_1.default, null, hasAnswer && react_1.default.createElement("img", { style: { maxWidth: '100%' }, src: userImage, alt: "" })),
                react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, padding: true },
                    react_1.default.createElement(Pane_1.default, { grow: true }),
                    !!showDelete && (react_1.default.createElement(Button_1.default, { style: { minWidth: 132 }, label: lib_i18n_1.default.t('delete'), onClick: handleCancel })),
                    !!showTake && (react_1.default.createElement(Button_1.default, { style: { minWidth: 132 }, label: lib_i18n_1.default.t('take-photo'), onClick: handleClickTake })),
                    react_1.default.createElement(Pane_1.default, { grow: true }))),
            !!showImageEditor && (react_1.default.createElement(ImageEditorDialog_1.default, { dataUrl: userImage, onCancel: handleCancel, onAccept: handleAccept })),
            !!showImageTaker && (react_1.default.createElement(ImageTakerDialog_1.default, { onCancel: handleCancel, onAccept: handleAcceptTake }))));
    }
    return (react_1.default.createElement(WizardDialog_1.default, { title: lib_i18n_1.default.t('select-yourself'), steps: steps, size: DialogSize_1.default.X450_Y250, onComplete: () => __awaiter(this, void 0, void 0, function* () {
            handleDone();
        }), closable: false, onClose: onClose, allowNext: handleAllowNext }));
}
exports.PickStaffDialog = PickStaffDialog;
exports.default = PickStaffDialog;
